import Vue from 'vue'
import SeoHelper from "../vue-components/helpers/SeoHelper.js";
import App from './App.vue'
import router from './router'
import store from './store'

import {
    BadgePlugin,
    ButtonPlugin,
    ImagePlugin,
    CardPlugin,
    ModalPlugin,
    CarouselPlugin,
    MediaPlugin,
    EmbedPlugin,
    FormPlugin,
    FormInputPlugin,
    FormGroupPlugin,
    FormCheckboxPlugin,
    FormRadioPlugin,
    FormTextareaPlugin,
    InputGroupPlugin,
    NavbarPlugin,
    NavPlugin,
    DropdownPlugin,
    TabsPlugin,
    LayoutPlugin,
    VBModalPlugin
} from 'bootstrap-vue'

import MainPage from './layout/main-page'
import VueScrollTo from 'vue-scrollto'
// import VueGtag from "vue-gtag";
// import { pageview } from 'vue-gtag'

/* eslint no-unused-vars: off */
import * as filters from './vue-global';
import VueSwal from 'vue-swal'
import VueMeta from 'vue-meta'
import EImgSmart from '../vue-components/components/e-img-smart.vue';
import EDownloadForm from '../vue-components/components/e-download-form.vue';
import WebsitePage from '@/layout/website-page.vue';
import FeatureCard from '@/components/feature-card.vue';
import YouTubePlayer from '@/components/youtube-player.vue';
import TestimonialCard from '@/components/testimonial-card.vue';

window.isNullOrUndefined = function(n) {
    return n === null || undefined === n
};
window.isStringEmpty = function(n) {
    return n == null || `` === n
};
window.getValueOrDefault = function(n, t) {
    return isNullOrUndefined(n) ? t : n
};
window.fillIntegerWithZero = function(n) {
    return n < 10 ? `0` + n : n
};

Vue.config.productionTip = false;

Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
Vue.use(ImagePlugin);
Vue.use(CardPlugin);
Vue.use(ModalPlugin);
Vue.use(MediaPlugin);
Vue.use(EmbedPlugin);
Vue.use(CarouselPlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(InputGroupPlugin);
Vue.use(NavbarPlugin);
Vue.use(NavPlugin);
Vue.use(DropdownPlugin);
Vue.use(TabsPlugin);
Vue.use(LayoutPlugin);
Vue.use(VBModalPlugin);

Vue.use(VueSwal);
Vue.use(VueMeta);
Vue.use(VueScrollTo, {
    offset: -84
});

// Vue.use(VueGtag, {
//     config: {
//         id() {
//             return window.env.VUE_APP_G_TAG;
//         }
//     }
// });

Vue.component(`main-page`, MainPage);
Vue.component(`e-img`, EImgSmart);
Vue.component(`e-download-form`, EDownloadForm);
Vue.component(`website-page`, WebsitePage);
Vue.component(`feature-card`, FeatureCard);
Vue.component(`youtube-player`, YouTubePlayer);
Vue.component(`testimonial-card`, TestimonialCard);

// SEO Part
SeoHelper.siteName = `Eye-In Media`;
Vue.prototype.$appName = `Eye-In Media`;
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        if (to.meta.title) {
            document.title = `${Vue.prototype.$appName} | ${to.meta.title}`;
        } else {
            document.title = `${Vue.prototype.$appName} | Digital Signage, Restaurant Menuboards, Self-Ordering, Guest WiFi`;
        }
        if (gtag) {
            gtag(`event`, `page_view`, {
                page_path: to.path,
                page_location: to.fullPath,
                page_title: document.title
            });
        }
    });
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount(`#app`);
